import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.983 10a6.1 6.1 0 0 0-6.096 6.095 6.1 6.1 0 0 0 6.096 6.096 6.1 6.1 0 0 0 6.095-6.096A6.1 6.1 0 0 0 23.983 10Zm7.884 9.143a4.574 4.574 0 0 1 4.572-4.572 4.574 4.574 0 0 1 4.571 4.572 4.574 4.574 0 0 1-4.571 4.572 4.574 4.574 0 0 1-4.572-4.572ZM35.908 26c0-.42.342-.762.762-.762 2.1 0 4.2.17 6.299.51a3.048 3.048 0 0 1 2.443 2.175l.474 1.664c.017.06.032.12.045.18.354 1.608-.694 3.19-2.286 3.622-1.53.415-3.259.73-4.64.883a.762.762 0 0 1-.841-.674L35.908 26ZM9.836 34.36a.762.762 0 0 1-.84.674 32.378 32.378 0 0 1-4.64-.883c-1.593-.432-2.64-2.014-2.287-3.622.013-.06.028-.12.045-.18l.474-1.664A3.048 3.048 0 0 1 5.03 26.51c2.1-.34 4.199-.51 6.299-.51.42 0 .761.34.761.761L9.837 34.36Zm1.955-19.027a4.574 4.574 0 0 0-4.572 4.572 4.574 4.574 0 0 0 4.572 4.572 4.574 4.574 0 0 0 4.571-4.572 4.574 4.574 0 0 0-4.571-4.572ZM23.983 37.43c-4.537 0-7.871-.43-10.03-1.312a3.048 3.048 0 0 1-1.836-3.417l.592-2.97a5.333 5.333 0 0 1 4.778-4.27c1.734-.148 3.898-.222 6.496-.222 2.598 0 4.762.074 6.495.221a5.333 5.333 0 0 1 4.779 4.271l.592 2.97a3.048 3.048 0 0 1-1.836 3.417c-2.16.883-5.493 1.312-10.03 1.312Z",
    fill: "currentColor"
  }));
};

var SvgConference = styled(SvgComponent).withConfig({
  displayName: "Conference__SvgConference",
  componentId: "sc-106hgr8-0"
})(["", " ", ""], size, color);
export default SvgConference;